<template>
  <MonthlyDateFilterSelector
    class="my-4"
    placeholder="Sélectionner une période"
    @newDateSelected="updateBulkTransferData"
  />
  <GenericButton @click="exportBulkTransferData">Exporter</GenericButton>
</template>

<script>
import { GenericButton, download } from "@estaly/ui";
import MonthlyDateFilterSelector from "@/components/menu/MonthlyDateFilterSelector.vue";
import { mapActions } from "vuex";

export default {
  components: {
    GenericButton,
    MonthlyDateFilterSelector,
  },

  emits: ["success"],

  data: () => {
    return {
      bulkTransferData: {
        startDate: null,
        endDate: null,
      },
    };
  },

  methods: {
    ...mapActions("notifications", ["notify"]),
    ...mapActions("invoices", ["downloadInvoicesQontoBulkTransferCSV"]),

    updateBulkTransferData(startDate, endDate) {
      this.bulkTransferData["startDate"] = startDate;
      this.bulkTransferData["endDate"] = endDate;
    },

    async exportBulkTransferData() {
      const response = await this.downloadInvoicesQontoBulkTransferCSV(this.bulkTransferData);
      if (response?.status === 204) {
        return this.notify({
          category: "simple",
          type: "error",
          title: "No data found for the selected period.",
        });
      }

      download(response.data, "qonto_bulk_transfer.csv");
      this.$emit("success");
      this.notify({
        category: "simple",
        type: "success",
        title: "Exporting merchants transfers file.",
      });
    },
  },
};
</script>
